import { render, staticRenderFns } from "./show-for-tab-all.vue?vue&type=template&id=0cb54dbc"
import script from "./show-for-tab-all.vue?vue&type=script&lang=js"
export * from "./show-for-tab-all.vue?vue&type=script&lang=js"
import style0 from "./show-for-tab-all.vue?vue&type=style&index=0&id=0cb54dbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports